import { render, staticRenderFns } from "./DairySupport.vue?vue&type=template&id=f86ec2c0&"
import script from "./DairySupport.vue?vue&type=script&lang=js&"
export * from "./DairySupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports